import { ContentModel } from "../common/models/content.model";

export class FooterModel{
    name?: string;
    label?: string;
  cqPath?: string;
    link?: string;
    type?: string;
    document?: string;
    navigationType?: string;
    category?: string
    
    constructor(params?: Partial<FooterModel>) {
        Object.assign(this, params);
      }
}

export class FooterData {
  cqPath?: string;
  links: FooterModel[];
  labels: ContentModel[];
}